module.exports = __webpack_public_path__ + "static/media/training.9b097614.png";